import { KeyboardDatePicker } from '@material-ui/pickers';
import React, { useEffect } from 'react';
import { setChannels, setEndFilterDate, setStartFilterDate } from '../../../redux/actions';
import { useAppDispatch } from '../../../redux/hooks';
import { getChannels } from '../../../utils/api';
import { useDateFilters } from '../../../utils/hooks';

const DateSelectors = (): JSX.Element => {
  const [startDate, endDate] = useDateFilters();

  const dispatch = useAppDispatch();

  const handleStartDateChange = (date: Date | null) => {
    dispatch(setStartFilterDate(date));
  };

  //update channels each time the date changes
  useEffect(() => {
    getChannels(startDate, endDate).then((res) => dispatch(setChannels(res)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const handleEndDateChange = (date: Date | null) => {
    dispatch(setEndFilterDate(date));
  };
  return (
    <>
      <KeyboardDatePicker
        variant="dialog"
        format="MM/dd/yyyy"
        margin="normal"
        label="Start"
        value={startDate}
        onChange={handleStartDateChange}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        maxDate={endDate}
      />
      <KeyboardDatePicker
        variant="dialog"
        format="MM/dd/yyyy"
        margin="normal"
        label="End"
        value={endDate}
        onChange={handleEndDateChange}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        minDate={startDate}
      />
    </>
  );
};

export default React.memo(DateSelectors);
